import { useEffect, useState } from 'react'
import { apiClient, useAuthStore } from '@indipia/shared'
import type { ScheduleDetailResponse } from '../types/gantt.types'
import { sumScheduleRequestCount } from '../constants/scheduleReplaceNotice.logic'

/** 확인창이 열린 스케줄의 고객 요청 건수 — 스케줄 상세 응답 tasks[] 의 requestCount 합계. 조회 중·실패·scheduleId 없음은 null(건수 없는 안내로 대체) */
export function useScheduleRequestCount(scheduleId: number | null | undefined): number | null {
  const user = useAuthStore(s => s.user)
  const [count, setCount] = useState<number | null>(null)

  useEffect(() => {
    setCount(null)
    if (scheduleId == null) return
    const controller = new AbortController()
    const headers = {
      ...(user?.compId   ? { 'X-Comp-Id': String(user.compId) }   : {}),
      ...(user?.memberId ? { 'X-User-Id': String(user.memberId) } : {}),
    }
    apiClient
      .get<{ data: ScheduleDetailResponse }>(`/schedule/schedules/${scheduleId}`, { headers, signal: controller.signal })
      .then(res => { if (!controller.signal.aborted) setCount(sumScheduleRequestCount(res.data.data?.tasks)) })
      .catch(() => { /* 집계를 못 구하면 건수 없는 안내를 쓴다 */ })
    return () => controller.abort()
  }, [scheduleId, user?.compId, user?.memberId])

  return count
}
